import { ref } from 'vue';
import { fetchShopConfigurationsNest } from '@/composables/shop/ShopsConfiguration';

export const isWorkshopAccount = ref(false);

export async function initWorkshopMode(shopId?: number): Promise<void> {
  if (!shopId) {
    isWorkshopAccount.value = false;
    return;
  }

  try {
    const config = await fetchShopConfigurationsNest(shopId, ['workshop_mode']);
    isWorkshopAccount.value = config?.workshop_mode === 'true';
  } catch {
    isWorkshopAccount.value = false;
  }
}
